import { useState } from "react";
import { X } from "lucide-react";
import { AshokaChakra } from "@/components/AshokaChakra";
import { todaysNationalDay } from "@/data/nationalDays";

export function FestivalBanner() {
  const override = new URLSearchParams(window.location.search).get("festival");
  const day = todaysNationalDay(new Date(), override);
  const storageKey = day ? `bg_banner_${day.slug}_${new Date().getFullYear()}` : null;
  const [dismissed, setDismissed] = useState(() => (storageKey ? localStorage.getItem(storageKey) === "1" : false));

  if (!day || dismissed) return null;

  const close = () => {
    localStorage.setItem(storageKey, "1");
    setDismissed(true);
  };

  return (
    <div className="relative z-30 overflow-hidden text-white" data-testid={`festival-banner-${day.slug}`} role="status">
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#e2731a_0%,#ff9933_35%,#0b3d91_50%,#138808_65%,#0e6a06_100%)]" />
      <div className="relative mx-auto flex max-w-7xl items-center gap-3 px-5 py-2.5 sm:px-8">
        <AshokaChakra className="h-6 w-6 shrink-0 text-white chakra-spin" />
        <p className="min-w-0 flex-1 text-sm leading-snug">
          <span className="font-devanagari text-base">{day.hindi}</span>
          <span className="mx-2 opacity-70">·</span>
          <span className="font-semibold" data-testid="festival-banner-title">{day.title}</span>
          <span className="hidden sm:inline"><span className="mx-2 opacity-70">·</span>{day.note}</span>
        </p>
        <button onClick={close} aria-label="Dismiss greeting" data-testid="festival-banner-close" className="shrink-0 rounded-full p-1 transition-colors hover:bg-white/20">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
